<template>
  <div>
    <div style="background-color: #e8e8e8; border-radius: 10px" class="py-2">
      <template v-if="loadingFilter">
        <div class="text-center" style="height: 300px; padding-top: 100px">
          <scale-loader :color="$vuetify.theme.primary" height="30px" width="7px"></scale-loader>
        </div>
      </template>
      <template v-else>
        <div class="pa-2">Search:</div>
        <v-layout wrap row class="mb-0">
          <v-flex xs12 sm6>
            <div class="px-2 mb-2">
              <v-autocomplete
                v-model="filter.product"
                :items="products"
                flat
                hide-no-data
                hide-details
                label="Product"
                solo
                @input="onSelectedProduct"
              ></v-autocomplete>
            </div>
            <div class="px-2 mb-2">
              <v-autocomplete
                :disabled="!headTypes || headTypes.length == 0"
                v-model="filter.headType"
                :items="headTypes"
                flat
                hide-no-data
                hide-details
                label="Head Type"
                solo
              ></v-autocomplete>
            </div>
            <div class="px-2">
              <v-autocomplete
                :disabled="!sizes || sizes.length == 0"
                v-model="filter.size"
                :items="sizes"
                flat
                hide-no-data
                hide-details
                label="Size"
                solo
              ></v-autocomplete>
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <div class="px-2 mb-2">
              <v-autocomplete
                :disabled="!filter.product && models.length == 0"
                v-model="filter.model"
                :items="models"
                flat
                hide-no-data
                hide-details
                label="Model"
                solo
                @input="onSelectedModel"
              ></v-autocomplete>
            </div>
            <div class="px-2">
              <v-autocomplete
                :disabled="!colors || colors.length == 0"
                v-model="filter.color"
                :items="colors"
                flat
                hide-no-data
                hide-details
                label="Color"
                solo
              ></v-autocomplete>
            </div>
          </v-flex>
          <v-flex xs12 sm12 class="text-center pt-2">
            <v-btn outline color="grey" @click="clearFilter">Clear</v-btn>
            <v-btn depressed color="primary" @click="applyFilter">Apply</v-btn>
          </v-flex>
        </v-layout>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  components: {
    ScaleLoader
  },
  data() {
    return {
      loadingFilter: false,
      filterMaster: {},
      filter: {
        product: '',
        model: '',
        headType: '',
        color: '',
        size: ''
      },
      // searchProduct: null,
      // searchModel: null,
      // searchHeadType: null,
      // searchColor: null,
      // searchSize: null,
      products: [],
      models: [],
      headTypes: [],
      colors: [],
      sizes: []
    }
  },
  mounted() {
    this.getFilterProduct()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageid() {
      return this.selectedBot.pageid
    },
    selectedProduct() {
      return this.filter.product
    },
    selectedModel() {
      return this.filter.model
    }
  },
  methods: {
    getFilterProduct() {
      var vm = this
      var data = {
        pageid: vm.pageid
      }

      vm.loadingFilter = true
      api.getLamyFilterProductMaster(data, function (error, response) {
        if (response.responsecode == 200) {
          const filterProductMaster = response.filter
          vm.filterMaster = filterProductMaster
          vm.products = Object.keys(filterProductMaster)
          vm.loadingFilter = false
        } else {
          console.error(error)
          return
        }
      })
    },
    applyFilter() {
      this.$emit('onFilter', this.filter)
    },
    clearFilter() {
      this.filter = {
        product: '',
        model: '',
        headType: '',
        color: '',
        size: ''
      }

      this.products = []
      this.models = []
      this.headTypes = []
      this.colors = []
      this.sizes = []

      this.$emit('onFilter', this.filter)
      this.getFilterProduct()
    },
    onSelectedProduct(val) {
      this.resetFilter()
      this.filter.product = val
      var data = this.filterMaster
      var models = data[val].model

      this.models = Object.keys(models)
    },
    onSelectedModel(val) {
      this.resetFilter()
      var data = this.filterMaster
      var currentProduct = this.filter.product
      var models = data[currentProduct].model
      var currentModelData = models[val]

      this.colors = currentModelData.colour
      this.headTypes = currentModelData.headtype
      this.sizes = currentModelData.size
    },
    resetFilter() {
      this.filter.headType = ''
      this.filter.color = ''
      this.filter.size = ''
      this.colors = []
      this.headTypes = []
      this.sizes = []
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/OverviewFilter.vue